import {Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';

import {BsModalRef} from 'ngx-bootstrap/modal';
import {SessionStorageService} from 'ngx-store';
import {AlertService} from 'ngx-alerts';

import {Md5} from 'ts-md5/dist/md5';
import {WsSpa, Funcoes} from '../../../../services';


@Component({
  selector: 'app-form-usuario',
  templateUrl: './form-usuario.component.html'
})
export class FormUsuarioComponent implements OnInit {

  @Output() action = new EventEmitter();
  @ViewChild('buscaCidades') buscaCidades;

  public bsConfig = {dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-primary', locale: 'br'};
  public usuario;
  public page;
  public formUsuario: FormGroup;
  public associado;
  public admin;
  public loaders = {
    errorCEL: false, errorTEL: false, errorCPF: false, errorCEP: false,
    errorPAS: false, errorPAA: false, errorASS: false, loadCidades: false, loading: false
  };
  constructor(private formBuilder: FormBuilder,
              private alert: AlertService,
              private wsSpa: WsSpa,
              private funcoes: Funcoes,
              private storage: SessionStorageService,
              public  bsModalRef: BsModalRef) {
    this.admin = (this.storage.get('usuario').tipo === 'G');
  }

  ngOnInit() {
    this.formUsuario = this.formBuilder.group({
      id:             [null],
      associado:      (this.page.tipo === 'novo') ? [null, Validators.required] : null,
      nome:           [null, Validators.required],
      cpf:            [null],
      est_impacto:    [null, Validators.required],
      sexo:           [null],
      email:          [null, Validators.required],
      usuario:        [null, Validators.required],
      tipo:           ['A'],
      departamento:   [null],
      celular:        [null],
      telefone:       [null],
      data_nasc:      [null],
      municipio:      [null],
      nome_cid:       [null],
      bairro:         [null],
      cpl_ender:      [null],
      nro_ender:      [null],
      endereco:       [null],
      cep:            [null],
      status:         ['A'],
      senha_atual:    (this.page.pagPai !== 'usuarios') ? [null, Validators.required] : null,
      senha_nova:     [null],
      rep_senha_nova: [null],
      senha:          (this.page.pagPai === 'usuarios' && this.page.tipo === 'novo') ? [null, Validators.required] : null,
      rep_senha:      (this.page.pagPai === 'usuarios' && this.page.tipo === 'novo') ? [null, Validators.required] : null
    });
    this.loaders.errorPAA = (this.page.pagPai !== 'usuarios');
    console.log(this.usuario);
    if (this.page.tipo === 'alterar') {
      this.formUsuario.patchValue({
        id:             this.usuario.id,
        associado:      this.usuario.associado,
        nome:           this.usuario.nome,
        cpf:            this.usuario.cpf,
        est_impacto:    this.usuario.est_impacto,
        sexo:           this.usuario.sexo,
        email:          this.usuario.email,
        celular:        this.usuario.celular,
        telefone:       this.usuario.telefone,
        data_nasc:      new Date(this.usuario.data_nasc),
        municipio:      this.usuario.municipio,
        nome_cid:       this.usuario.nome_cid,
        bairro:         this.usuario.bairro,
        cpl_ender:      this.usuario.cpl_ender,
        nro_ender:      this.usuario.nro_ender,
        endereco:       this.usuario.endereco,
        cep:            this.usuario.cep,
        status:         this.usuario.status,
        departamento:   this.usuario.departamento,
        tipo:           this.usuario.tipo

      })
    }
  }

  public verifyValid(campo) {
    return this.formUsuario.controls[campo].errors &&
        (this.formUsuario.controls[campo].dirty || this.formUsuario.controls[campo].touched)
  }

  public verifyReq(campo) {
    return this.formUsuario.get(campo).errors['required'];
  }

  public setUsuario() {
    this.loaders.loading = true;
    this.wsSpa.setFunction('insert/usuario', this.formUsuario.value, 'spaUrl')
        .subscribe(
            data => this.trataRetorno(data),
            error => this.trataErro(error.message)
        )
  }

  public trataRetorno(retorno) {
    this.loaders.loading = false;
    if (retorno['status'] === 'OK') {
      this.alert.success(retorno.mensagem);
      this.action.emit(true);
      setTimeout(() => {
        this.formUsuario.reset();
        this.bsModalRef.hide();
      }, 1000);
    } else {
      this.alert.danger(retorno.mensagem);
    }
  }

  public trataErro(erro) {
    this.loaders.loading = false;
    this.alert.danger(erro)
  }

  public verifySenha(senha, rep_senha) {
    if (senha && rep_senha) {
      this.loaders.errorPAS = (senha !== rep_senha);
      if (!this.loaders.errorPAS) {
        this.formUsuario.patchValue({senha: senha});
      }
    }
  }

  public verifySenhaAt(senhaAt) {
    this.loaders.errorPAA = !(Md5.hashStr(senhaAt) === this.usuario.senha);
  }

  public trataFone(fone, tipo) {
    const scope = this;
    if (fone.value) {
      const format = /[ !@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]/;
      const traco = /[-]/;
      this.loaders.errorCEL = false;
      this.loaders.errorTEL = false;
      if (fone.value.length === 8 && !traco.test(fone.value) && !format.test(fone.value)) {
        atualizaValor(fone);
      } else if (fone.value.length === 9 && !traco.test(fone.value) && !format.test(fone.value)) {
        atualizaValor(fone);
      } else if (fone.value.length === 9 && traco.test(fone.value) && !format.test(fone.value)) {
        atualizaValor(fone);
      } else if (fone.value.length === 10 && traco.test(fone.value) && !format.test(fone.value)) {
        atualizaValor(fone);
      } else {
        if (fone.id === 'celular') {
          this.loaders.errorCEL = true;
        } else if (fone.id === 'telefone') {
          this.loaders.errorTEL = true;
        }
      }
    }

    function atualizaValor(foneAt) {
      const valor = foneAt.value.replace('-', '');
      const pInt = (valor.length === 8) ? valor.substr(0, 4) : valor.substr(0, 5);
      const sInt = (valor.length === 8) ? valor.substr(4, 8) : valor.substr(5, 9);
      if (tipo === 'celular') {
        scope.formUsuario.patchValue({celular: pInt + '-' + sInt});
      } else {
        scope.formUsuario.patchValue({telefone: pInt + '-' + sInt});
      }
    }
  }

  public trataCPF(cpf) {
    if (cpf.value) {
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      let result = false;
      if (cpf.value.length === 11 && !format.test(cpf.value)) {
        const pInt = cpf.value.substr(0, 3);
        const sInt = cpf.value.substr(3, 3);
        const tInt = cpf.value.substr(6, 3);
        const qInt = cpf.value.substr(9, 2);
        this.formUsuario.patchValue({cpf: pInt + '.' + sInt + '.' + tInt + '-' + qInt});

        result = this.funcoes.validaCPF(cpf.value);
      } else if (cpf.value.length === 14 && format.test(cpf.value)) {
        result = this.funcoes.validaCPF(cpf.value);
      } else {
        result = false;
      }

      if (!result && cpf.value) {
        this.loaders.errorCPF = true;
      }
    }
  }

  public buscaCep(cep) {
    if (cep.value) {
      const traco = /[-]/;
      if (cep.value.length === 9 && traco.test(cep.value)) {
        this.formUsuario.patchValue({cep: cep.value});
        this.loaders.errorCEP = false;
      } else if (cep.value.length === 8 && !traco.test(cep.value)) {
        const pInt = cep.value.substr(0, 5);
        const sInt = cep.value.substr(5, 3);
        this.formUsuario.patchValue({cep: pInt + '-' + sInt});
        this.loaders.errorCEP = false;
      } else {
        this.loaders.errorCEP = true;
      }
      if (!this.loaders.errorCEP) {
        this.wsSpa.getFunction('search/cep/cep', cep.value, 'spaUrl')
            .subscribe(
                data => this.updateEndereco(data),
                error => this.trataErro(error.message)
            )
      }
    }
  }

  public updateEndereco(resp) {
    resp = resp[0];
    if (resp) {
      this.formUsuario.patchValue({
        nome_cid:  resp.cidade,
        municipio: resp.cod_ibge,
        bairro:    resp.bairro,
        endereco:  resp.logradouro
      });
    } else {
      this.formUsuario.patchValue({
        nome_cid:  null,
        municipio: null,
        bairro:    null,
        endereco:  null
      });
    }
  }

  public onSelectCidade(cidade) {
    this.formUsuario.patchValue({
      nome_cid:  cidade.nome,
      municipio: cidade.id
    });
  }

  public verifyAssoc(codigo) {
    if (codigo && this.page.tipo === 'novo') {
      this.wsSpa.getFunction('search/associado/codigo', codigo.toString(), 'spaUrl')
          .subscribe(
              data => this.loaders.errorASS = !(data[0]),
              error => this.trataErro(error),
          );
    }
  }

  public mostraCidades() {
    this.loaders.loadCidades = true;
    setTimeout(() => {
      this.buscaCidades.show()
    });
  }

}
